import axios from 'axios';
import { getPlatformBaseUrl } from './platformBaseUrl';

export default function configureAxios() {
  const platformBaseUrl = getPlatformBaseUrl();
  axios.defaults.baseURL = platformBaseUrl === undefined ? '' : platformBaseUrl;
}
